module.exports = __webpack_public_path__ + "img/album23_02.29a73c57.jpg";